module.exports = __webpack_public_path__ + "img/Arrow_Up.13ff7683.svg";